import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";
import { stationarySourceEnforcementActionRouteName } from "../enforcementAction/enforcementAction";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  stationarySourceEnforcementActions: "StationarySourceEnforcementAction.StationarySourceEnforcementActions",
  list: "StationarySourceEnforcementAction.StationarySourceEnforcementActionsList",
  // new: "StationarySourceEnforcementAction.StationarySourceEnforcementActionNew",
  base: "StationarySourceEnforcementAction.StationarySourceEnforcementActionBase",
  view: "StationarySourceEnforcementAction.StationarySourceEnforcementActionView",
  edit: "StationarySourceEnforcementAction.StationarySourceEnforcementActionEdit",
  documents: "StationarySourceEnforcementAction.StationarySourceEnforcementActionDocuments",
  documentsEdit: "StationarySourceEnforcementAction.StationarySourceEnforcementActionDocumentsEdit",
  documentsNew: "StationarySourceEnforcementAction.StationarySourceEnforcementActionDocumentsNew",
  audit: "StationarySourceEnforcementAction.StationarySourceEnforcementActionAudit",
};

export { names as stationarySourceEnforcementActionRouteNames };

const stationarySourceEnforcementActionRoutes: RouterOptions["routes"] = [
  {
    path: "/stationarySourceEnforcementAction",
    name: names.stationarySourceEnforcementActions,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Stationary Source Enforcement Actions",
          lookupGroups: ["DeliveryMethod", "EnforcementActionType", "InspectionCategory"],
        },
        component: () =>
          import("@/views/stationarySourceEnforcementActions/StationarySourceEnforcementActionsList.vue"),
      },
      // {
      //   path: "new/:inspectionId(\\d+)?",
      //   component: () => import("@/views/stationarySourceEnforcementActions/StationarySourceEnforcementActionBase.vue"),
      //   redirect: { name: names.new },
      //   props: true,
      //   children: [
      //     {
      //       path: "",
      //       name: names.new,
      //       meta: { title: "New Enforcement Action", isNew: true },
      //       component: () =>
      //         import("@/views/stationarySourceEnforcementActions/StationarySourceEnforcementActionEdit.vue"),
      //     },
      //   ],
      // },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/stationarySourceEnforcementActions/StationarySourceEnforcementActionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Stationary Source Enforcement Action View" },
            component: () => import("@/views/enforcementAction/EnforcementActionView.vue"),
            props: { entityRouteName: stationarySourceEnforcementActionRouteName },
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Stationary Source Enforcement Action Edit", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionEdit.vue"),
            props: { entityRouteName: stationarySourceEnforcementActionRouteName },
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Stationary Source Enforcement Action Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="stationarySourceEnforcementAction" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Stationary Source Enforcement Action Document", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionDocument.vue"),
            props: { resourceTypeKey: "stationarySourceEnforcementAction" },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Stationary Source Enforcement Action Documents", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionDocuments.vue"),
            props: { resourceTypeKey: "stationarySourceEnforcementAction" },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Stationary Source Enforcement Action Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="EnforcementAction" />,
            },
          },
        ],
      },
    ],
  },
];
export default stationarySourceEnforcementActionRoutes;
